/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import ViewMode from "App/view/modes/view_mode";
import RenderDocument from "App/render_document";
import {vec2} from "gl-matrix";
import View from "App/view/view";

export default
class ViewVR extends View {

    protected positionL: vec2;
    protected sizeL: vec2;

    protected positionR: vec2;
    protected sizeR: vec2;

    constructor(aViewMode: ViewMode, aDocument: RenderDocument, aPositionPct: vec2, aSizePct: vec2) {
        super(aViewMode, aDocument, aPositionPct, aSizePct);
    }

    public render() {
        this._renderRight();
        this._renderLeft();
    }

    protected _setPositionAndSize(aContentSize: vec2) {
        super._setPositionAndSize(aContentSize);

        this.positionL = vec2.fromValues(aContentSize[0] * (this.viewPositionPct[0] / 100), aContentSize[1] * (this.viewPositionPct[1] / 100));
        this.sizeL = vec2.fromValues(aContentSize[0] * (this.viewSizePct[0] / 100) / 2, aContentSize[1] * (this.viewSizePct[1] / 100));

        let xoffset = aContentSize[0] * (this.viewSizePct[0] / 100) / 2;

        this.positionR = vec2.fromValues(xoffset + (aContentSize[0] * (this.viewPositionPct[0] / 100)), aContentSize[1] * (this.viewPositionPct[1] / 100));
        this.sizeR = vec2.fromValues(aContentSize[0] * (this.viewSizePct[0] / 100) / 2, aContentSize[1] * (this.viewSizePct[1] / 100));

        this.position = this.positionL;
        this.size = this.sizeL;
    }

    protected _renderLeft() {
        this.position = this.positionL;
        this.size = this.sizeL;

        this.document.render(this);
    }

    protected _renderRight() {
        this.position = this.positionR;
        this.size = this.sizeR;

        this.document.render(this);
    }

}
